export default {
  init() {
    // JavaScript to be fired on all pages
    $('[data-toggle="toggle"]').click(function() {
      var selector = $(this).data('target');
      $(selector).toggleClass('in');
      $('body').toggleClass('menu-in');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js